import { gql } from "@apollo/client";

const GET_SURVEY_QUESTION = gql`
  query SurveyQuestion($order: Int!, $surveyType: Int!) {
    surveyQuestion(order: $order, surveyType: $surveyType) {
      id
      questionText
      questionType
      order
      surveyType
      surveyAnswers {
        id
        answerText
      }
    }
  }
`;

export default GET_SURVEY_QUESTION;
